module.exports = __webpack_public_path__ + "static/media/tl.7942bccb.svg";